import { format, parse } from "date-fns"
import { MINUTES_TO_MILLIS } from "lopermut"

const TIME_FORMAT = "HH:mm"

// Mirrors the backend grace period before a launch without a schedule starts
const LAUNCH_GRACE_PERIOD_MILLIS = 2 * MINUTES_TO_MILLIS

export function toTimeInputValue(date: Date) {
  return format(date, TIME_FORMAT)
}

export function combineDateAndTime(date: Date | undefined, time: string) {
  if (!date || !time) return undefined

  return parse(time, TIME_FORMAT, date)
}

export function isUpcoming(date: Date) {
  return date > new Date()
}

export function isImminent(date: Date) {
  return date.getTime() - Date.now() <= LAUNCH_GRACE_PERIOD_MILLIS
}

export function formatLaunchTime(date: Date, locale: string) {
  return new Intl.DateTimeFormat(locale, {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    timeZoneName: "short",
  }).format(date)
}
